import * as React from "react";
import Button from "../../Button";
import { CalendarIcon, CrossIcon, DeleteIcon } from "../../icons";
import "./index.css";
import Stars from "../../../images/stars.png";
import TrendUpRed from "../../../images/trend-up-red.png";
import AddToClassified from "../../../images/add-to-classified.png";
import { createPortal } from "react-dom";
import AddPictures from "../../../images/add-pictures.png";
import AddToFeatured from "../../../images/add-to-featured.png";
import Flatpickr from "react-flatpickr";
import Switch from "react-switch";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";

import "flatpickr/dist/flatpickr.css";
import ExplainerBox from "../../ExplainerBox";
import { selectAuth } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import { useGetSingleUserQuery } from "../../../features/supabase/usecase/users";
import PaymentSuccessModal from "../../Modals/PaymentSuccessModal";
import { useNavigate } from "react-router-dom";

const Cart = ({
  onProceedToCheckout,
  onBack,
  data,
  onSubmitIfFree,
  disabled,
}) => {
  const [pinnedPackage, setPinnedPackage] = React.useState(false);
  const [pinnedDates, setPinnedDates] = React.useState([]);
  const [shabbosPinnedDates, setShabbosPinnedDates] = React.useState([]);
  const [pinnedDatesValue, setPinnedDatesValue] = React.useState([]);
  const pinnedAmount = 39.99;

  const user = useSelector(selectAuth);

  const { data: userData, error: userError } = useGetSingleUserQuery(
    user?.user?.id
  );

  const additionalPicturesAmount = 3;

  const [featuredPackage, setFeaturedPackage] = React.useState(false);
  const [featuredDates, setFeaturedDates] = React.useState([]);
  const [shabbosFeaturedDates, setShabbosFeaturedDates] = React.useState([]);
  const [featuredDatesValue, setFeaturedDatesValue] = React.useState([]);
  const featuredAmount = 39.99;

  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (data) {
      if (data.pinnedPackage) setPinnedPackage(data.pinnedPackage);
      if (data.featuredPackage) setFeaturedPackage(data.featuredPackage);
      if (data.pinnedDates) setPinnedDates(data.pinnedDates);
      if (data.featuredDates) setFeaturedDates(data.featuredDates);
      if (data.shabbosPinnedDates)
        setShabbosPinnedDates(data.shabbosPinnedDates);
      if (data.shabbosFeaturedDates)
        setShabbosFeaturedDates(data.shabbosFeaturedDates);
      if (data.pinnedDatesValue) setPinnedDatesValue(data.pinnedDatesValue);
      if (data.featuredDatesValue)
        setFeaturedDatesValue(data.featuredDatesValue);
    }
  }, [data]);

  const totalPinned = React.useMemo(() => {
    var total = 0;
    if (pinnedDates.length > 0) total += pinnedAmount * pinnedDates.length;
    if (shabbosPinnedDates.length > 0)
      total -= pinnedAmount * shabbosPinnedDates.length;
    return total;
  }, [pinnedDates, shabbosPinnedDates]);

  const totalFeatured = React.useMemo(() => {
    var total = 0;
    if (featuredDates.length > 0)
      total += featuredAmount * featuredDates.length;
    if (shabbosFeaturedDates.length > 0)
      total -= featuredAmount * shabbosFeaturedDates.length;
    return total;
  }, [featuredDates, shabbosFeaturedDates]);

  // const [days, setDays] = React.useState(0);

  const subtotal = React.useMemo(() => {
    var total = data?.price || 0;
    if (pinnedDates.length > 0) total += pinnedAmount * pinnedDates.length;
    if (shabbosPinnedDates.length > 0)
      total -= pinnedAmount * shabbosPinnedDates.length;
    if (featuredDates.length > 0)
      total += featuredAmount * featuredDates.length;
    if (shabbosFeaturedDates.length > 0)
      total -= featuredAmount * shabbosFeaturedDates.length;
    if (data.additionalPictures > 0)
      total += data.additionalPictures * additionalPicturesAmount;
    return total;
  }, [
    pinnedAmount,
    additionalPicturesAmount,
    featuredAmount,
    pinnedDates,
    featuredDates,
    shabbosPinnedDates,
    shabbosFeaturedDates,
  ]);

  return (
    <section className="submit-cart-page container">
      <span className="cart-title">Adds-Ons</span>
      {/* <div className="cart-plan-tile">
        <span>{data?.title}</span>
        <span>{["Jobs Classified", "Other Classified"].includes(data?.title) ? "$0.00" : "$9.99"}</span>
      </div> */}

      <div className="topup-container">
        <div className="topup-content">
          <img src={Stars} alt={"Stars"} />
          <div>
            <div className="topup-question">
              <div>{"Pin your post to the top of the category"}</div>
            </div>
            <div>
              <div className="plan-container-divider" />
              <div>
                {
                  <CustomCalendar
                    onDateChange={(dates) => {
                      setPinnedDates(dates);
                      if (!pinnedPackage) {
                        setShabbosPinnedDates(
                          dates.filter((e) => e.getDay() === 6)
                        );
                      }
                    }}
                    onClear={(value) => {
                      if (value) setPinnedPackage(value);
                      setPinnedDatesValue([]);
                      setShabbosPinnedDates([]);
                      setPinnedDates([]);
                    }}
                    dates={pinnedDates}
                    multiple={pinnedPackage}
                    total={totalPinned}
                    value={pinnedDatesValue}
                    onValueChange={(dates) => {
                      setPinnedDatesValue(dates);
                    }}
                  />
                }
              </div>
              <div className="plan-container-items">
                <span>Pinned to top</span>
                <span>${pinnedAmount}</span>
              </div>
              <div className="plan-container-items">
                <span>
                  Qty <b>({pinnedDates.length})</b>
                </span>
                <span>${(pinnedDates.length * pinnedAmount).toFixed(2)}</span>
              </div>
              {shabbosPinnedDates.length > 0 && (
                <div className="plan-container-items">
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div>Subtracted for Shabbos</div> <ExplainerBox />
                  </span>
                  <span>
                    -$
                    {(pinnedAmount * shabbosPinnedDates.length).toFixed(2)}
                  </span>
                </div>
              )}
              <div className="plan-container-items">
                <span>Total:</span>
                <span>${totalPinned.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
        <img className="topup-image" src={AddToClassified} alt="topup image" />
      </div>
      <div className="topup-container">
        <div className="topup-content">
          <img src={TrendUpRed} alt={"Stars"} />
          <div>
            <div className="topup-question">
              {"Feature your classified on the collive homepage"}
            </div>
            <div>
              <div className="plan-container-divider" />
              <div>
                {
                  <CustomCalendar
                    onDateChange={(dates) => {
                      setFeaturedDates(dates);
                      if (!featuredPackage) {
                        setShabbosFeaturedDates(
                          dates.filter((e) => e.getDay() === 6)
                        );
                      }
                    }}
                    dates={featuredDates}
                    onClear={(value) => {
                      if (value) setFeaturedPackage(value);
                      setFeaturedDatesValue([]);
                      setShabbosFeaturedDates([]);
                      setFeaturedDates([]);
                    }}
                    multiple={featuredPackage}
                    total={totalFeatured}
                    value={featuredDatesValue}
                    onValueChange={(dates) => {
                      setFeaturedDatesValue(dates);
                    }}
                  />
                }
              </div>
              <div className="plan-container-items">
                <span>Featured on Homepage</span>
                <span>${featuredAmount}</span>
              </div>
              <div className="plan-container-items">
                <span>
                  Qty <b>({featuredDates.length})</b>
                </span>
                <span>
                  ${(featuredAmount * featuredDates.length).toFixed(2)}
                </span>
              </div>
              {shabbosFeaturedDates.length > 0 && (
                <div className="plan-container-items">
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div>Subtracted for Shabbos</div> <ExplainerBox />
                  </span>
                  <span>
                    -$
                    {(featuredAmount * shabbosFeaturedDates.length).toFixed(2)}
                  </span>
                </div>
              )}
              <div className="plan-container-items">
                <span>Total:</span>
                <span>${totalFeatured.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
        <img className="topup-image" src={AddToFeatured} alt="topup image" />
      </div>

      <span className="cart-title">Cart</span>
      <div className="cart-bill-container">
        <div className={`cart-bill-container-field cart-bill-category`}>
          {data?.title}
          <span>{`\$${(data.price || 0.0).toFixed(2)}`}</span>
        </div>
        {pinnedDates.length > 0 &&
          Array.from([
            {
              title: "Pinned to Top",
              price: `Qty(${pinnedDates.length})`,
              type: "header",
            },
            {
              title: "Price:",
              price: `$${pinnedAmount}`,
              type: "price",
            },
            {
              title: "Total:",
              price: `$${(pinnedAmount * pinnedDates.length).toFixed(2)}`,
              type: "price",
            },
            shabbosPinnedDates.length > 0 && {
              title: "Subtracted for Shabbos:",
              price: `-$${(pinnedAmount * shabbosPinnedDates.length).toFixed(
                2
              )}`,
              type: "price",
            },
          ]).map((e, i) => (
            <div
              className={`cart-bill-container-field ${
                e.type === "header" ? "cart-bill-category" : ""
              }`}
            >
              {e.title}
              <span>{e.price}</span>
            </div>
          ))}
        {featuredDates.length > 0 &&
          Array.from([
            {
              title: "Featured on Homepage",
              price: `Qty(${featuredDates.length})`,
              type: "header",
            },
            {
              title: "Price:",
              price: `$${featuredAmount}`,
              type: "price",
            },
            {
              title: "Total:",
              price: `$${(featuredAmount * featuredDates.length).toFixed(2)}`,
              type: "price",
            },
            shabbosFeaturedDates.length > 0 && {
              title: "Subtracted for Shabbos:",
              price: `-$${(
                featuredAmount * shabbosFeaturedDates.length
              ).toFixed(2)}`,
              type: "price",
            },
          ]).map((e, i) => (
            <div
              className={`cart-bill-container-field ${
                e.type === "header" ? "cart-bill-category" : ""
              }`}
            >
              {e.title}
              <span>{e.price}</span>
            </div>
          ))}
        {data.additionalPictures > 0 &&
          Array.from([
            {
              title: "Additional Pictures",
              price: `Qty(${data.additionalPictures})`,
              type: "header",
            },
            {
              title: "Price:",
              price: `$${additionalPicturesAmount}`,
              type: "price",
            },
            {
              title: "Total:",
              price: `$${data.additionalPictures * additionalPicturesAmount}`,
              type: "price",
            },
          ]).map((e, i) => (
            <div
              className={`cart-bill-container-field ${
                e.type === "header" ? "cart-bill-category" : ""
              }`}
            >
              {e.title}
              <span>{e.price}</span>
            </div>
          ))}
        <div className={`cart-bill-container-field cart-bill-category`}>
          Total
          <span>${subtotal.toFixed(2)}</span>
        </div>
      </div>
      {user && userData?.allow_free && (
        <span
          style={{
            color: "#888",
            fontStyle: "italic",
            display: "block",
            textAlign: "right",
            marginBottom: "10px",
          }}
        >
          {"* You can post for free "}
        </span>
      )}
      <div className={`submit-information-footer form-page-footer`}>
        <button className={`btn-as-left active`} onClick={onBack}>
          Previous
        </button>
        {user && (userData?.allow_free || subtotal === 0) ? (
          <button
            onClick={async () => {
              const result = await onSubmitIfFree({
                pinnedPackage,
                additionalPictures: data.additionalPictures,
                category_id: data.category_id,
                featuredPackage,
                pinnedDates,
                featuredDates,
                shabbosPinnedDates,
                shabbosFeaturedDates,
                pinnedDatesValue,
                featuredDatesValue,
                shabbosDiscountAmount: -(
                  shabbosPinnedDates.length * pinnedAmount +
                  shabbosFeaturedDates.length * featuredAmount
                ).toFixed(2),
                finalAmount: 0,
              });
              console.log(user);
              if (user.user) setShowSuccessModal(true);
            }}
            className={`btn-as-right ${disabled ? "disabled" : "active"}`}
            disabled={disabled}
          >
            Submit Classified
          </button>
        ) : (
          <button
            onClick={() =>
              onProceedToCheckout({
                pinnedPackage,
                additionalPictures: data.additionalPictures,
                category_id: data.category_id,
                featuredPackage,
                pinnedDates,
                featuredDates,
                shabbosPinnedDates,
                shabbosFeaturedDates,
                pinnedDatesValue,
                featuredDatesValue,
                shabbosDiscountAmount: -(
                  shabbosPinnedDates.length * pinnedAmount +
                  shabbosFeaturedDates.length * featuredAmount
                ).toFixed(2),
                finalAmount: subtotal.toFixed(2),
              })
            }
            className={`btn-as-right active`}
          >
            Proceed to checkout
          </button>
        )}
      </div>
      {showSuccessModal && (
        <PaymentSuccessModal
          isOpen={true}
          onClose={() => {
            setShowSuccessModal(false);
            navigate("/dashboard?tab=pending");
          }}
          receipt={null}
        />
      )}
    </section>
  );
};
const CustomCalendar = ({
  value,
  dates,
  onDateChange,
  onValueChange,
  total,
  multiple,
  onClear,
}) => {
  const fp = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [mode, setMultiple] = React.useState(multiple);
  const [showMonths, setShowMonths] = React.useState(
    window.innerWidth < 600 ? 1 : 2
  );
  const [options, setOptions] = React.useState({
    mode: "range",
    minDate: "today",
    showMonths: showMonths,
  });

  const getAllDatesInRange = (date) => {
    const start = new Date(date[0]);
    if (date.length === 1) return [start];
    const end = new Date(date[1]);
    const dates = [];
    while (start <= end) {
      dates.push(new Date(start));
      start.setDate(start.getDate() + 1);
    }
    return dates;
  };

  // Update options when mode or showMonths changes
  React.useEffect(() => {
    setOptions({
      mode: mode ? "multiple" : "range",
      minDate: "today",
      showMonths: showMonths,
    });
  }, [mode, showMonths]);

  // Update showMonths on window resize
  React.useEffect(() => {
    const handleResize = () => {
      setShowMonths(window.innerWidth < 600 ? 1 : 2);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    if (value.length === 0) {
      fp.current.flatpickr.clear();
    }
  }, [value]);

  const handleChange = (value) => {
    onClear(value);
    setMultiple(value);
    fp.current.flatpickr.open();
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {fp.current &&
        createPortal(
          <span className={`plan-container-row ${open && "show"}`}>
            <div
              className={`plan-container-button ${mode && "selected"}`}
              onClick={() => handleChange(false)}
            >
              Select Range
            </div>
            <div
              className={`plan-container-button ${!mode && "selected"}`}
              onClick={() => handleChange(true)}
            >
              Select Random Dates
            </div>
          </span>,
          fp.current.flatpickr.calendarContainer
        )}
      <Flatpickr
        ref={fp}
        value={value}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(date) => {
          if (date.length === 0) return;
          onValueChange(date);
          if (mode) {
            onDateChange(date);
          } else {
            if (date.length === 1) return;
            onDateChange(getAllDatesInRange(date));
          }
        }}
        options={options}
        render={({ defaultValue, value, ...props }, ref) => (
          <button
            className="plan-date-pick-wrapper"
            onClick={(e) => {
              if (e.target.id === "date") return;
              if (fp.current.flatpickr.isOpen) {
                fp.current.flatpickr.close();
              } else {
                fp.current.flatpickr.open();
              }
            }}
          >
            <input
              id="date"
              ref={ref}
              {...props}
              style={{ height: 0, width: 0, opacity: 0 }}
            />
            <div>Select Dates</div>
            <CalendarIcon size={10} className={"calendar-icon"} />
          </button>
        )}
      />
      {dates.length > 0 && (
        <div
          className="plan-container-button selected"
          onClick={() => onClear()}
        >
          Clear Calendar
        </div>
      )}
    </div>
  );
};

export default Cart;
